import React from "react";
import Select, { components } from 'react-select';

const OptionMulti = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const OptionSingle = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const CustomMultiValue = (props) => {
  return (
    <components.MultiValue {...props}><span title={props.data.label}>{props.data.label}</span></components.MultiValue>
  );
};

const ReactSelect = (props) => {

  let {
    isMulti,
    options,
    className,
    placeholder,
    menuIsOpen,
    value,
    onChange,
    isSearchable,
    isClearable,
    style,
    placeholderColor,
    arrowColor,
  } = props;

  const components = {
    Option: isMulti ? OptionMulti : OptionSingle,
    MultiValue: CustomMultiValue
  };

  const greenBefore = {
    position: 'absolute',
    zIndex: '1',
    content: '""',
    top: isSearchable === false ? '9px' : '7px',
    right: '8px',
    width: '20px',
    height: '20px',
    border: 'solid 1px #b9c8ca',
    borderRadius: '50%',
    pointerEvents: 'none',
    backgroundColor: '#fff'
  };
  const greenAfter = {
    position: 'absolute',
    zIndex: '1',
    content: '""',
    right: '14px',
    bottom: isSearchable === false ? '14.5px' : '16.5px',
    pointerEvents: 'none',
    width: '0',
    height: '0',
    borderLeft: '4px solid transparent',
    borderRight: '4px solid transparent',
    borderTop: '4px solid #068184'
  };

  const greyBefore = {
    position: 'absolute',
    zIndex: '1',
    content: '""',
    top: '7px',
    right: '8px',
    width: '20px',
    height: '20px',
    border: 'none',
    borderRadius: '50%',
    pointerEvents: 'none',
    backgroundColor: '#fbfcfc'
  };
  const greyAfter = {
    position: 'absolute',
    zIndex: '1',
    content: '""',
    right: '12px',
    bottom: isSearchable === false ? '14.5px' : '16.5px',
    pointerEvents: 'none',
    width: '9px',
    height: '0',
    borderLeft: '4px solid transparent',
    borderRight: '4px solid transparent',
    borderTop: '4px solid #4C5B61',
    top: '16px'
  };

  if (!style) {
    style = 'base';
  }

  let customStyles = {
    'custom_dropdown': {
      menuTop: 8,
      menuLeft: -14,
      valueContainerTop: -8,
      indicatorsContainerTop: -10
    },
    'custom_dropdown2': {
      menuTop: -2,
      menuLeft: -14,
      valueContainerTop: 0,
      indicatorsContainerTop: 0
    },
    'base': {
      menuTop: 8,
      menuLeft: -20,
      valueContainerTop: -4,
      indicatorsContainerTop: -4
    }
  };

  if (!customStyles[style]) {
    style = 'base';
  }

  let container = base => ({
    ...base,
  });

  let menu = base => ({
    ...base,
    top: customStyles[style].menuTop,
    left: customStyles[style].menuLeft,
    position: 'relative',
    zIndex: 2
  });

  // if (minimalWidth) {
  //   container = base => ({
  //     ...base,
  //     '@media (min-width: 768px)': {
  //       width: `${minimalWidth}px !important`
  //     }
  //   });
  //   menu = base => ({
  //     ...base,
  //     top: customStyles[style].menuTop,
  //     left: customStyles[style].menuLeft,
  //     position: 'relative',
  //     zIndex: 2,
  //     '@media (min-width: 768px)': {
  //       width: minimalWidth - 5
  //     }
  //   });
  // }

  let styles = {
    container: container,
    valueContainer: base => ({
      ...base,
      maxWidth: '250px',
      alignItems: 'center',
      top: customStyles[style].valueContainerTop,
      padding: 0,
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    }),
    control: base => ({
      ...base,
      border: 'none',
      backgroundColor: 'transparent',
      maxHeight: '100%',
      minHeight: '100%',
      paddingLeft: 0,
      width: '100%',
      boxShadow: 'none'
    }),
    placeholder: base => ({
      ...base,
      color: placeholderColor || '#068184'
    }),
    input: base => ({
      ...base,
      lineHeight: 1,
      fontSize: 16,
      color: '#7f8a8a',
      maxWidth: 250
    }),
    indicatorSeparator: base => ({
      ...base,
      visibility: 'hidden'
    }),
    indicatorsContainer: base => ({
      ...base,
      maxHeight: 38,
      top: customStyles[style].indicatorsContainerTop,
      left: arrowColor === 'grey' ? 30 : 13,
      position: 'relative',
      '&:before': arrowColor === 'grey' ? greyBefore : greenBefore,
      '&:after': arrowColor === 'grey' ? greyAfter : greenAfter
    }),
    menu: menu,
    singleValue: base => ({
      ...base,
      position: 'static',
      transform: 'none',
    })
  };

  return (
    <Select
      isMulti={isMulti}
      isClearable={true}
      options={options}
      className={className}
      placeholder={placeholder}
      closeMenuOnSelect={isMulti ? false : true}
      blurInputOnSelect={false}
      hideSelectedOptions={false}
      components={components}
      styles={styles}
      value={value}
      isSearchable={isSearchable}
      isClearable={isClearable}
      onChange={onChange}
      menuIsOpen={menuIsOpen} />
  );
};

export default ReactSelect;